import React, { useState, useEffect } from "react";
import EmployeeListPanel from "./EmployeeListPanel";
import { employees } from "./EmployeeData";
import ProductivityProgressCard from "./ProductivityProgressCard";
import BreakdownCard from "./BreakdownCard";

const EmployeeDashBoard = ({ departmentFilter }) => {
   const [selectedEmployee, setSelectedEmployee] = useState(employees[0]);

   const filteredEmployees = employees.filter((emp) => {
        if (departmentFilter === 0) return true;
        const deptMap = {
            1: "Engineering",
            2: "Marketing",
            3: "Customer Success",
            4: "Design",
            5: "Operations",
        };
        return emp.details.department === deptMap[departmentFilter];
    });

    useEffect(() => {
        if (!filteredEmployees.includes(selectedEmployee)) {
            setSelectedEmployee(filteredEmployees[0]);
        }
    }, [departmentFilter]);

    return (
        <div className="flex flex-col">
            <div className="space-y-6">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    <div className="col-span-1">
                        <EmployeeListPanel
                            employees={filteredEmployees}
                            selectedEmployee={selectedEmployee}
                            onSelect={setSelectedEmployee}
                        />
                    </div>
                    <div className="col-span-2 space-y-6">
                        <ProductivityProgressCard employee={selectedEmployee}/>
                        <BreakdownCard employee={selectedEmployee}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeDashBoard;